import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const closeEdgeContextMenu: GraphCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.edgeContextMenu = null;
  });
};
